import {
  getRequest,
  URL,
  postRequest,
  putRequest,
  deleteRequest,
} from "shared/utils";
import * as types from "./actionTypes";

const queryParms = (request) => {
  const {
    clientId,
    category,
    statusIds,
    searchKeyword,
    filters,
    pageNumber,
    pageSize,
    sortColumn,
    sortDirection,
    isAdminView,
    dueDateStart,
    dueDateEnd,
    excludePreTransaction,
    isDeleteRequested = false,
    isDeleted = false,
  } = request;

  let parms = isAdminView
    ? `?clientId=${clientId}&category=${category}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    : `?clientId=${clientId}&category=${category}&pageNumber=${pageNumber}&pageSize=${pageSize}&isDeleted=${isDeleted}`;

  if (sortColumn) {
    parms += `&sortColumn=${sortColumn}&sortDirection=${sortDirection}`;
  }

  if (dueDateStart && dueDateEnd) {
    parms += `&dueDateStart=${dueDateStart}&dueDateEnd=${dueDateEnd}`;
  }

  if (searchKeyword) {
    parms += `&searchKeyword=${searchKeyword}`;
  }

  if (statusIds) {
    statusIds.forEach((s) => {
      parms += `&statusIds=${s}`;
    });
  }

  if (filters) {
    Object.keys(filters).forEach((key, index) => {
      var filterBy = filters[key];

      // Skip userDefinedFields as it will be handled separately
      if (key === "userDefinedFields") {
        return;
      }

      if (key === "atRisk" || key === "onHold" || key === "isDeleteRequested") {
        parms += `&${key}=${filterBy}`;
      }

      if (filterBy && filterBy.length > 0) {
        filterBy.forEach((f) => {
          parms += `&${key}=${encodeURIComponent(f)}`;
        });
      }
    });

    // Handle userDefinedFields separately as Dictionary<string, List<string>>
    if (filters.userDefinedFields && typeof filters.userDefinedFields === 'object') {
      Object.keys(filters.userDefinedFields).forEach((fieldName) => {
        const fieldValues = filters.userDefinedFields[fieldName];
        
        if (Array.isArray(fieldValues) && fieldValues.length > 0) {
          fieldValues.forEach((value) => {
            // Format: userDefinedFields[fieldName]=value
            parms += `&userDefinedFields[${encodeURIComponent(fieldName)}]=${encodeURIComponent(value)}`;
          });
        }
      });
    }
  }

  if (excludePreTransaction !== undefined && excludePreTransaction !== null) {
    parms += `&excludePreTransaction=${excludePreTransaction}`;
  }
  return parms;
};

export function getTransactions(requestWithParams, modalList) {
  const url = `${URL.transaction}${queryParms(requestWithParams)}`;

  const listType = modalList
    ? types.GET_PRE_TRANSACTIONS_LIST
    : types.GET_TRANSACTIONS;
  const request = getRequest(url);

  return {
    type: listType,
    payload: request,
  };
}

export function getTransaction(id, requestWithParams) {
  const url = `${URL.transaction}/${id}${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION,
    payload: request,
  };
}

export function setTransactionFilters(filters) {

  return {
    type: types.SET_TRANSACTION_FILTERS,
    payload: filters,
  };
}

//udf = user defined fields
export function getTransactionsUDF(clientId) {
  const url = `${URL.transaction}/udf/settings?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_UDF,
    payload: request,
  };
}

export function updateTransactionUDF(clientId, list, userEmail) {
  const url = `${URL.transaction}/udf/settings`;

  const request = putRequest(url, {
    clientId,
    settings: list,
    updatedBy: userEmail,
  });

  return {
    type: types.UPDATE_TRANSACTION_UDF,
    payload: request,
  };
}

export function getTransactionSpreadsheet(parms) {
  var utcOffset = new Date().getTimezoneOffset() / 60;

  utcOffset = utcOffset * -1;

  let url = `${URL.transaction}/spreadsheet`;

  const { filters } = parms;

  delete parms.filters;

  for (var prop in filters) {
    if (Array.isArray(filters[prop]) && filters[prop].length === 0)
      delete filters[prop];
  }

  const columns = parms.columns;

  const request = postRequest(
    url,
    { ...parms, ...filters, utcOffset, columns },
    false,
    "blob"
  );

  return {
    type: types.GET_TRANSACTION_SPREADSHEET,
    payload: request,
  };
}

export function getPreTransaction(id) {
  const url = `${URL.transaction}/${id}`;

  const request = getRequest(url);

  return {
    type: types.GET_PRE_TRANSACTION,
    payload: request,
  };
}

export function getTransactionComments(txId) {
  const url = `${URL.transaction}/${txId}/comments`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_COMMENTS,
    payload: request,
  };
}

export function getTransactionDocuments(txId) {
  const url = `${URL.transaction}/${txId}/documents`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_DOCUMENTS,
    payload: request,
  };
}

export function getTransactionDocumentUrl(
  txId,
  documentId,
  documentPath,
  documentName
) {
  const url = `${
    URL.transaction
  }/${txId}/document/${documentId}/url?documentPath=${encodeURIComponent(
    documentPath
  )}&documentName=${encodeURIComponent(documentName)}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_DOCUMENTS,
    payload: request,
  };
}

export function getTransactionDefaultSteps(clientId) {
  const url = `${URL.transaction}/steps/default?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_DEFAULT_STEPS,
    payload: request,
  };
}

export function getTransactionDefaultTasks() {
  const url = `${URL.transaction}/tasks/default`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_DEFAULT_TASKS,
    payload: request,
  };
}

export function getTransactionSteps(txId) {
  const url = txId
    ? `${URL.transaction}/${txId}/steps`
    : `${URL.transaction}/steps`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_STEPS,
    payload: request,
  };
}

export function getTransactionStepComments(txId, stepId) {
  const url = `${URL.transaction}/${txId}/steps/${stepId}/comments`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_STEP_COMMENTS,
    payload: request,
  };
}

export function getTransactionStepsDocuments(txId, stepIds = []) {
  let url = `${URL.transaction}/${txId}/documents?`;

  stepIds.forEach((s) => {
    url += `&stepIds=${s}`;
  });

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_STEPS_DOCUMENTS,
    payload: request,
  };
}

export function getTransactionTemplates(clientId) {
  const url = `${URL.transaction}/templates?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_TEMPLATES,
    payload: request,
  };
}

export function updateTransactionTemplate(params) {
  const url = `${URL.transaction}/template`;

  const request = putRequest(url, params);

  return {
    type: types.UPDATE_TRANSACTION_TEMPLATE,
    payload: request,
  };
}

export function deleteTransactionTemplate(params) {
  const url = `${URL.transaction}/template?id=${params.id}&clientId=${params.clientId}&deletedBy=${params.deletedBy}`;

  const request = deleteRequest(url, params).then(() =>
    Promise.resolve(params.id)
  );

  return {
    type: types.DELETE_TRANSACTION_TEMPLATE,
    payload: request,
  };
}

export function addTransactionTemplate(params) {
  const url = `${URL.transaction}/template`;

  const request = postRequest(url, params);

  return {
    type: types.ADD_TRANSACTION_TEMPLATE,
    payload: request,
  };
}

export function addTransactionStepDocument(addDocumentRequest) {
  const url = `${URL.transaction}/document`;

  var body = addDocumentRequest;

  const request = postRequest(url, body);

  return {
    type: types.ADD_TRANSACTION_STEP_DOCUMENT,
    payload: request,
  };
}

export function updateTransactionStepDocument(updateDocumentRequest) {
  const url = `${URL.transaction}/document`;

  var body = updateDocumentRequest;

  const request = putRequest(url, body);

  return {
    type: types.ADD_TRANSACTION_STEP_DOCUMENT,
    payload: request,
  };
}

export function deleteTransactionStepDocument(id, deletedBy) {
  const url = `${URL.transaction}/document?id=${id}&deletedBy=${deletedBy}`;

  const request = deleteRequest(url);

  return {
    type: types.ADD_TRANSACTION_STEP_DOCUMENT,
    payload: request,
  };
}

export function updateTransactionStepDueDate(stepId, stepDueDate, modifiedBy) {
  const url = `${URL.transaction}/steps/${stepId}/dueDate`;

  var body = { stepDueDate, modifiedBy };

  const request = putRequest(url, body);

  return {
    type: types.UPDATE_TRANSACTION_STEP_DUE_DATE,
    payload: request,
  };
}

export function updateTransactionStepDate(stepId, params) {
  const url = `${URL.transaction}/steps/${stepId}/dates`;

  const request = putRequest(url, params);

  return {
    type: types.UPDATE_TRANSACTION_STEP_DATES,
    payload: request,
  };
}

export function updateTransactionStepStatus(stepId, modifiedBy) {
  const url = `${URL.transaction}/steps/${stepId}/status`;

  var body = { modifiedBy };

  const request = putRequest(url, body);

  return {
    type: types.UPDATE_TRANSACTION_STEP_STATUS,
    payload: request,
  };
}

export function getTransactionTasks(txId) {
  const url = txId
    ? `${URL.transaction}/${txId}/tasks`
    : `${URL.transaction}/tasks/default`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_TASKS,
    payload: request,
  };
}

export function getTransactionTasksForClient(clientId) {
  const url = `${URL.transaction}/${clientId}/tasks/default`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_TASKS,
    payload: request,
  };
}

export function getTransactionTasksUncompleted(txId) {
  const url = `${URL.transaction}/${txId}/tasks/uncompleted`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_TASKS_UNCOMPLETED,
    payload: request,
  };
}

export function addTransactionTask(stepId, taskName, txId, createdBy) {
  const url = `${URL.transaction}/task`;

  var body = {
    taskName,
    createdBy,
    stepId,
    transactionId: txId,
  };

  const request = postRequest(url, body);

  return {
    type: types.ADD_TRANSACTION_TASK,
    payload: request,
  };
}

export function addTransactionDefaultTask(body) {
  const url = `${URL.transaction}/task/defaults`;

  const request = postRequest(url, body);

  return {
    type: types.ADD_TRANSACTION_TASK,
    payload: request,
  };
}

export function reorderTransactionTasks(reorderedTasks, modifiedBy) {
  const url = `${URL.transaction}/task/reorder?modifiedBy=${modifiedBy}`;

  const request = putRequest(url, reorderedTasks);

  return {
    type: types.REORDER_TRANSACTION_TASKS,
    payload: request,
  };
}

export function reorderTransactionDefaultTasks(reorderedTasks, modifiedBy) {
  const url = `${URL.transaction}/task/defaults/reorder?modifiedBy=${modifiedBy}`;

  const request = putRequest(url, reorderedTasks);

  return {
    type: types.REORDER_TRANSACTION_TASKS,
    payload: request,
  };
}

export function updateTransactionTask(task) {
  const url = `${URL.transaction}/task`;

  const request = putRequest(url, task);

  return {
    type: types.UPDATE_TRANSACTION_TASK,
    payload: request,
  };
}

export function updateTransactionTaskId(body, modifiedBy) {
  const { taskId, transactionTypeId, isDeleted, stepId , clientId } = body;

  let url = `${URL.transaction}/task/default/deleted?taskId=${taskId}`;
  url += `&transactionTypeId=${transactionTypeId}&isDeleted=${isDeleted}&modifiedBy=${modifiedBy}
  &stepId=${stepId}&clientId=${clientId}`;

  const request = putRequest(url);

  return {
    type: types.UPDATE_TRANSACTION_TASK,
    payload: request,
  };
}

export function deleteTransactionTasks(taskIds, deletedBy) {
  let url = `${URL.transaction}/tasks?deletedBy=${deletedBy}`;

  taskIds.forEach((t) => {
    url += `&ids=${t}`;
  });

  const request = deleteRequest(url);

  return {
    type: types.DELETE_TRANSACTION_TASKS,
    payload: request,
  };
}

export function completeTransaction(body) {
  const url = `${URL.transaction}/complete`;

  const request = putRequest(url, body);

  return {
    type: types.COMPLETE_TRANSACTION,
    payload: request,
  };
}

export function deleteTransactionDefaultTask(id, deletedBy) {
  let url = `${URL.transaction}/task/default?id=${id}&deletedBy=${deletedBy}`;

  const request = deleteRequest(url);

  return {
    type: types.DELETE_TRANSACTION_TASKS,
    payload: request,
  };
}

export function getTransactionFilterOptions(clientId, category) {
  const url = `${URL.transaction}/filterOptions?clientId=${clientId}&category=${category}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_FILTER_OPTIONS,
    payload: request,
  };
}

export function getTransactionNames(clientId, category) {
  const url = `${URL.transaction}/names?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_NAMES,
    payload: request,
  };
}

export function getTransactionCities(clientId, category) {
  const url = `${URL.transaction}/cities?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_CITIES,
    payload: request,
  };
}

export function getTransactionStateProvinces(clientId, category) {
  const url = `${URL.transaction}/states?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_STATE_PROVINCES,
    payload: request,
  };
}

export function getTransactionCountries(clientId, category) {
  const url = `${URL.transaction}/countries?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_COUNTRIES,
    payload: request,
  };
}

export function getTransactionTypes(clientId, category) {
  const url = `${URL.transaction}/types?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_TYPES,
    payload: request,
  };
}

export function getTransactionTypesCustom(clientId) {
  const url = `${URL.transaction}/types/custom?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_TYPES_CUSTOM,
    payload: request,
  };
}

export const addTransactionTypeCustom = (data) => {
  const url = `${URL.transaction}/type/custom`;
  const request = postRequest(url, data);
  return {
    type: types.ADD_TRANSACTION_TYPE_CUSTOM,
    payload: request,
  };
};

export const updateTransactionTypesCustom = (data, modifiedBy) => {
  const url = `${URL.transaction}/types/custom?modifiedBy=${modifiedBy}`;
  const request = putRequest(url, data);
  return {
    type: types.UPDATE_TRANSACTION_TYPES_CUSTOM,
    payload: request,
  };
};

export const deleteTransactionTypeCustom = (data) => {
  const url = `${URL.transaction}/type/custom?id=${data.id}&deletedBy=${data.deletedBy}`;
  return deleteRequest(url).then(() => ({
    type: types.DELETE_TRANSACTION_TYPE_CUSTOM,
    payload: { id: data.id },
  }));
};

export function getTransactionStatuses(clientId, category) {
  const url = `${URL.transaction}/statuses?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_STATUSES,
    payload: request,
  };
}

export function updateTransactionStatus(txId, data) {
  const url = `${URL.transaction}/${txId}/status?transactionId=${txId}`;

  const request = putRequest(url, data);

  return {
    type: types.UPDATE_TRANSACTION_STATUS,
    payload: request,
  };
}

export function getTransactionManagers(clientId, category) {
  const url = `${URL.transaction}/managers?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_MANAGERS,
    payload: request,
  };
}

export function getTransactionBusinessUnits(clientId, category) {
  const url = `${URL.transaction}/businessUnits?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_BUSINESS_UNITS,
    payload: request,
  };
}

export function saveTransaction(data) {
  const url = `${URL.transaction}`;

  const request = postRequest(url, data);

  return {
    type: types.SAVE_TRANSACTION,
    payload: request,
  };
}

export function savePreTransaction(data) {
  const url = `${URL.transaction}/pre-transaction`;

  const request = postRequest(url, data);

  return {
    type: types.SAVE_TRANSACTION,
    payload: request,
  };
}

export function updateTransaction(data) {
  const url = `${URL.transaction}`;

  const request = putRequest(url, data);

  return {
    type: types.UPDATE_TRANSACTION,
    payload: request,
  };
}
export function cancelTransaction(data) {
  const url = `${URL.transaction}/cancel`;

  const request = putRequest(url, data);

  return {
    type: types.CANCEL_TRANSACTION,
    payload: request,
  };
}

export function updateTransactionAtRisk(transactionId, atRisk, modifiedBy) {
  const url = `${URL.transaction}/${transactionId}/atRisk?atRisk=${atRisk}&modifiedBy=${modifiedBy}`;

  const request = putRequest(url, { transactionId, atRisk, modifiedBy });

  return {
    type: types.UPDATE_TRANSACTION_AT_RISK,
    payload: request,
  };
}

export function getPreTransactionAssociated(id) {
  const url = `${URL.transaction}/${id}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_ASSOCIATED_PRE_TRANSACTION,
    payload: request,
  };
}

export function updateTransactionOnHold(transactionId, onHold, modifiedBy) {
  const url = `${URL.transaction}/${transactionId}/onHold?newValue=${onHold}&modifiedBy=${modifiedBy}`;

  const request = putRequest(url, {
    transactionId,
    newValue: onHold,
    modifiedBy,
  });

  return {
    type: types.UPDATE_TRANSACTION_UPLOAD_STATUS,
    payload: request,
  };
}

export function getLastStepOfPreTransaction(id) {
  const url = `${URL.transaction}/${id}/steps/last`;

  const request = getRequest(url);

  return {
    type: types.GET_LAST_STEP_OF_PRE_TRANSACTION,
    payload: request,
  };
}

export function saveTransactionAssocData(id, data, associatedDataId) {
  const url = `${URL.transaction}/${id}/${associatedDataId}`;

  const request = postRequest(url, data);

  let type;

  switch (associatedDataId) {
    case "properties":
      type = types.ASSIGN_PROPERTIES_TO_TRANSACTION;
      break;
    case "leaseEvents":
      type = types.ASSIGN_LEASE_EVENTS_TO_TRANSACTION;
      break;
    case "preTransactions":
      type = types.ASSIGN_PRE_TRANSACTION_TO_TRANSACTION;
      break;
    default:
      break;
  }
  return {
    type,
    payload: request,
  };
}

export function getTransactionAssocData(id, associatedDataId = "") {
  const url = `${URL.transaction}/${id}/${associatedDataId}`;

  const request = getRequest(url);

  let type;

  switch (associatedDataId) {
    case "properties":
      type = types.GET_TRANSACTION_ASSOCIATED_PROPERTIES;
      break;
    case "leaseEvents":
      type = types.GET_TRANSACTION_ASSOCIATED_LEASE_EVENTS;
      break;
    case "preTransactions":
      type = types.GET_TRANSACTION_ASSOCIATED_PRE_TRANSACTION;
      break;
    default:
      break;
  }
  return {
    type,
    payload: request,
  };
}

export const updateTransactionComment = (data) => {
  const url = `${URL.transaction}/comment`;
  const request = putRequest(url, data);
  return {
    type: types.UPDATE_TRANSACTION_COMMENT,
    payload: request,
  };
};

export const createTransactionComment = (data) => {
  const url = `${URL.transaction}/comment`;
  const request = postRequest(url, data);
  return {
    type: types.CREATE_TRANSACTION_COMMENT,
    payload: request,
  };
};

export const deleteTransactionComment = (data) => {
  const url = `${URL.transaction}/comment?id=${data.commentId}&deletedBy=${data.userEmail}`;
  return deleteRequest(url).then(() => ({
    type: types.DELETE_TRANSACTION_COMMENT,
    payload: { commentId: data.commentId },
  }));
};

export const getTransactionAudit = (id) => {
  const url = `${URL.transaction}/${id}/audits`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_AUDITS,
    payload: request,
  };
};

export const resetTransactionComments = () => ({
  type: types.RESET_TRANSACTION_COMMENTS,
});

export const resetPreTransactionAssociated = () => ({
  type: types.RESET_PRE_TRANSACTION_ASSOCIATED,
});

export function getAllTransactions(requestWithParams) {
  const url = `${URL.transaction}${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_ALL_TRANSACTIONS,
    payload: request,
  };
}

export const createTransactionFromPreTransaction = (id, userEmail) => {
  const url = `${URL.transaction}/${id}/convert?preTransactionId=${id}&convertedBy=${userEmail}`;

  const request = postRequest(url);

  return {
    type: types.CREATE_TRANSACTION_FROM_PRETRANSACTION,
    payload: request,
  };
};

export function archiveTransaction(data) {
  const url = `${URL.transaction}/admin-delete`;

  const request = deleteRequest(url, data);
  // const request = deleteRequest(url);

  return {
    type: types.DELETE_TRANSACTION,
    payload: request,
  };
}

export function unarchiveTransaction(data) {
  const url = `${URL.transaction}/admin-undelete`;

  const request = putRequest(url, data);

  return {
    type: types.UNDELETE_TRANSACTION,
    payload: request,
  };
}

export function deleteTransactionAssocData(id, data, associatedDataId) {
  let url;
  let type;

  switch (associatedDataId) {
    case "properties":
      url = `${URL.transaction}/${id}/property`;
      type = types.DELETE_TRANSACTION_ASSOCIATED_PROPERTIES;
      break;
    case "leaseEvents":
      url = `${URL.transaction}/${id}/leaseEvent`;
      type = types.DELETE_TRANSACTION_ASSOCIATED_LEASE_EVENTS;
      break;
    case "preTransactions":
      url = `${URL.transaction}/${id}/preTransaction`;
      type = types.DELETE_TRANSACTION_ASSOCIATED_PRE_TRANSACTION;
      break;
    default:
      break;
  }

  const request = deleteRequest(url, data);

  return {
    type,
    payload: request,
  };
}

export function getAddressDetails(address) {
  const url = `${
    URL.transaction
  }/getaddressdetails?address=${encodeURIComponent(address)}`;

  const request = getRequest(url);

  return {
    type: types.GET_ADDRESS_DETAILS,
    payload: request,
  };
}

export function getTransactionClientManagers(clientId, category) {
  const url = `${URL.transaction}/clientmanagers?category=${category}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_CLIENT_MANAGERS,
    payload: request,
  };
}

export function clearTransactionDetails() {
  return {
    type: types.CLEAR_TRANSACTION_DETAILS,
  };
}

export function getTransactionPageSize(userId, tableName) {
  const url = `${URL.transaction}/pageSize?userId=${userId}&tableName=${tableName}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_PAGE_SIZE,
    payload: request,
  };
}

export function getTransactionById(id) {
  const url = `${URL.transaction}/getTransactionById?Id=${id}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_BY_ID,
    payload: request,
  };
}

export const createDuplicateTransaction = (data) => {
  const url = `${URL.transaction}/duplicateTransaction`;
  const request = postRequest(url, data);
  return {
    type: types.DUPLICATE_TRANSACTION,
    payload: request,
  };
};

export function clearDuplicateTransaction() {
  return {
    type: types.CLEAR_DUPLICATE_TRANSACTION,
  };
}

export function updateTransactionDefaultStep(data) {
  const url = `${URL.transaction}/steps/default`;

  const request = putRequest(url, data);

  return {
    type: types.UPDATE_DEFAULT_STEP,
    payload: request,
  };
}

export function updateTransactionDefaultTask(data) {
  const url = `${URL.transaction}/task/default`;

  const request = putRequest(url, data);

  return {
    type: types.UPDATE_DEFAULT_TASK,
    payload: request,
  };
}

export function requestToDeleteTransaction(data) {
  const url = `${URL.transaction}/delete-request`;

  const request = putRequest(url, data);

  return {
    type: types.REQUEST_TO_DELETE_TRANSACTION,
    payload: request,
  };
}

export function getTransactionDeleteStatus(transactionId) {
  const url = `${URL.transaction}/delete-status?transactionId=${transactionId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_DELETE_STATUS,
    payload: request,
  };
}

  export function getTransactionActivity(transactionId) {
    const url = `${URL.transaction}/transaction-activity?transactionId=${transactionId}`;

    const request = getRequest(url);

    return {
      type: types.GET_TRANSACTION_ACTIVITY,
      payload: request,
    };
  }

export function setTransactionActivity(data) {
  const url = `${URL.transaction}/transaction-activity`;

  const request = postRequest(url, data);

  return {
    type: types.SET_TRANSACTION_ACTIVITY,
    payload: request,
  };
} 

export function getTansactionApprovers(clientId) {
  const url = `${URL.transaction}/transaction-approvers?clientId=${clientId}`;
  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_APPROVERS,
    payload: request,
  };
} 

export function getTansactionSelectedApprovers(data) {
  const { clientId, transactionId, stepId } = data;
  const url = `${URL.transaction}/selected-approvers?clientId=${clientId}&transactionId=${transactionId}&stepId=${stepId}`;

  const request = getRequest(url);
  
  return {
    type: types.GET_SELECTED_APPROVERS,
    payload: request,
  };
} 

export function getTansactionApprovalCard(data) {
  const { clientId, transactionId, stepId } = data;
  const url = `${URL.transaction}/transaction-approval-card?clientId=${clientId}&transactionId=${transactionId}&stepId=${stepId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_APPROVAL_CARD,
    payload: request,
  };
} 

export function getTansactionApproverResponse(data) {
  const { clientId, transactionId, stepId } = data;
  const url = `${URL.transaction}/approval-responses?clientId=${clientId}&transactionId=${transactionId}&stepId=${stepId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_APPROVAL_RESPONSE,
    payload: request,
  };
} 

export function getTansactionAllApproverResponse(data) {
  const { clientId, transactionId, stepId } = data;
  const url = `${URL.transaction}/approval-responses?clientId=${clientId}&transactionId=${transactionId}&stepId=${stepId}&&inludeRejectedflow=${true}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_ALL_APPROVAL_RESPONSE,
    payload: request,
  };
} 

export function getTansactionApproverComments(data) {
  const { clientId, transactionId, stepId } = data;
  const url = `${URL.transaction}/transaction-approval-comments?clientId=${clientId}&transactionId=${transactionId}&stepId=${stepId}`;

  const request = getRequest(url);

  return {
    type: types.GET_TRANSACTION_APPROVAL_COMMENTS,
    payload: request,
  };
} 

export function addTansactionApproverResponse(data) {
  const url = `${URL.transaction}/approval-responses`;

  const request = postRequest(url, data);

  return {
    type: types.ADD_TRANSACTION_APPROVAL_RESPONSE,
    payload: request,
  };
} 

export function addTansactionApproverDocument(data) {
  const url = `${URL.transaction}/approval-document`;

  const request = postRequest(url, data);

  return {
    type: types.ADD_TRANSACTION_APPROVAL_DOCUMENT,
    payload: request,
  };
} 

export function completeTransactionApproval(data) {
  const { clientId, transactionId, stepId, modifiedBy } = data;
  const url = `${URL.transaction}/complete-approval?clientId=${clientId}&transactionId=${transactionId}&stepId=${stepId}&modifiedBy=${modifiedBy}`;

  const request = putRequest(url);

  return {
    type: types.COMPLETE_TRANSACTION_APPROVAL,
    payload: request,
  };}